import React, { useEffect, useState } from "react";

const FocusDot = () => {
  const [pos, setPos] = useState({ x: 50, y: 50 });

  useEffect(() => {
    const interval = setInterval(() => {
      setPos({
        x: Math.random() * 80 + 10,
        y: Math.random() * 80 + 10,
      });
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative h-96 bg-gray-200 rounded-2xl">
      <div
        className="absolute w-6 h-6 bg-green-500 rounded-full transition-all duration-1000"
        style={{ left: `${pos.x}%`, top: `${pos.y}%` }}
      />
    </div>
  );
};

export default FocusDot;